import { useState } from 'react'
import { Button, Stack, Text } from '@grovus/design-system'
import type { Dict } from '../i18n'
import type { CreativesResponse } from './contract'
import { fill } from './format'

/**
 * How many accounts in scope were read over the whole window and delivered nothing, with
 * their names one click away. The count comes from `window.observedEmpty` alone: a missing
 * creative row or a zero spend says nothing about an account whose days were not all read.
 */
export function NoDeliveryLine({ response, t }: { response: CreativesResponse; t: Dict }) {
  const [open, setOpen] = useState(false)
  const empty = response.accounts.filter((account) => account.window.observedEmpty)
  if (empty.length === 0 || response.accounts.length === 0) return null
  return (
    <Stack gap={4} data-testid="no-delivery">
      <Button
        variant="subtle"
        size="compact-sm"
        onClick={() => setOpen((was) => !was)}
        aria-expanded={open}
        aria-controls="no-delivery-accounts"
        data-testid="no-delivery-toggle"
        style={{ alignSelf: 'flex-start' }}
      >
        {fill(t.noDelivery, { n: empty.length, t: response.accounts.length })}
      </Button>
      {open && (
        <Stack gap={2} id="no-delivery-accounts" data-testid="no-delivery-accounts">
          {empty.map((account) => (
            <Text key={account.id} size="sm">
              {account.name} ({account.short}){account.isDemo ? ` · ${t.demoMark}` : ''}
            </Text>
          ))}
        </Stack>
      )}
    </Stack>
  )
}
